<template>
  <div class="gisOther">
    <div class="gisOther-box">
      <div class="gisOther-content">
        <div class="gisOther-content-left">
          <div class="gisOther-content-one">专题图层可视化 \ 三维空间展示 \ 大数据分析</div>
          <div class="gisOther-content-two">GIS一张图空间规划平台</div>
          <div class="gisOther-content-four" style=" margin-top: 30px;">整合国土空间基础数据、通用行业应用数据，实现不同专题图</div>
          <div class="gisOther-content-four">层可视化展示，提供空间规划决策依据</div>
          <div class="client-btn" @click="toLogin">点击登录</div>
        </div>
        <div class="gisOther-content-right">
          <img src="../assets/img/yizhangtu_001.png" />
        </div>
      </div>
    </div>
    <div class="gisOther-content-box">
      <div class="gisOther-one">
        <div class="gisOther-one-left" id="wrapper-text">
          <div class="gisOther-text-one">专题图层可视化</div>
          <div class="gisOther-text-two">Thematic layer visualization</div>
          <div class="gisOther-text-three" style="margin-top:30px">提供不同业务数据图层，集成为一张图形式进行</div>
          <div class="gisOther-text-three">可视化展示。</div>
        </div>
        <div class="gisOther-one-right" id="wrapper-img">
          <img src="../assets/img/yizhangtu_01.png" />
        </div>
      </div>
      <div class="gisOther-two">
        <div class="gisOther-one-left" id="wrapper-text1">
          <div class="gisOther-text-one">三维空间展示</div>
          <div class="gisOther-text-two">3D space display</div>
          <div class="gisOther-text-three" style="margin-top:30px">整合空间数据，以三维形式展示地面建筑物或其</div>
          <div class="gisOther-text-three">他附着物信息。</div>
        </div>
        <div class="gisOther-one-right" id="wrapper-img1">
          <img src="../assets/img/yizhangtu_02.png" />
        </div>
      </div>
      <div class="gisOther-three">
        <div class="gisOther-one-left" id="wrapper-text2">
          <div class="gisOther-text-one">大数据分析</div>
          <div class="gisOther-text-two">Big data analysis</div>
          <div class="gisOther-text-three" style="margin-top:30px">结合大数据的整合资源、共享数据特点，对各类</div>
          <div class="gisOther-text-three">业务数据进行分类统计分析。</div>
        </div>
        <div class="gisOther-one-right" id="wrapper-img2">
          <img src="../assets/img/yizhangtu_03.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight gisOther-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft gisOther-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight gisOther-one-right'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft gisOther-one-left'
    );
    var x2 = document.getElementById('wrapper-img2');
    x2.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight gisOther-one-right'
    );
    var y2 = document.getElementById('wrapper-text2');
    y2.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft gisOther-one-left'
    );
  },
  methods: {
    toLogin() {
      window.open('https://zc.yunzhengshou.com/login');
    }
  }
};
</script>
<style>
.gisOther {
  width: 100%;
}
.gisOther-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.gisOther-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.gisOther-content-left {
  width: 50%;
  margin-top: 70px;
  margin-left: 30px;
}
.gisOther-content-right {
  width: 50%;
}
.gisOther-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.gisOther-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.gisOther-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.gisOther-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.other-content-right {
  margin-left: 77px;
}
.other-content-right img {
  margin-top: 20px;
  width: 750px;
  height: 600px;
}
.gisOther-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.gisOther-one,
.gisOther-two,
.gisOther-three {
  display: flex;
  padding: 50px 80px;
  overflow: hidden;
}
.gisOther-text-one {
  margin-top: 96px;
  font-family: 微软雅黑;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: rgb(73, 83, 98);
}
.gisOther-text-two {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 30px;
  color: #999999;
}
.gisOther-text-three {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.gisOther-one-left {
  width: 50%;
  padding-right: 150px;
}
.gisOther-one-right {
  width: 50%;
}
.gisOther-one-right img {
  width: 100%;
}
.client-btn {
  width: 110px;
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  border: 1px solid rgba(0, 189, 183, 1);
  text-align: center;
  line-height: 40px;
  color: rgba(0, 189, 183, 1);
  cursor: pointer;
  margin-top: 42px;
}
.client-btn:hover {
  color: rgb(41, 146, 151);
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .gisOther-content,
  .gisOther-content-box {
    width: 1200px !important;
  }
  .gisOther-content-two {
    font-size: 48px !important;
  }
  .gisOther-one-left {
    padding-right: 32px !important;
  }
  .gisOther-text-one {
    font-size: 36px !important;
  }
  .gisOther-text-two {
    font-size: 28px !important;
  }
  .gisOther-text-three {
    font-size: 24px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/gis-other.vue